export default __webpack_public_path__ + "static/media/howtoreadme.5bd150ba.gif";